module.exports = __webpack_public_path__ + "img/bp_button_pre_zjcx.30194e48.png";